module.exports = __webpack_public_path__ + "media/images/cancel-0f25984652ee328fc839a44fc2806629.svg";